<template>
  <picker-field
    :label="label"
    :value="value"
    title="选择单据"
    @onchange="onchange"
    ref="picker"
    @open="onSearch"
  >
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.name }}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "岗位名称",
    },
    value: String,
    moduleId: Number,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this;
      me.$emit("onchange", value);
    },
    onSearch() {
      var me = this;
      if (me.moduleId) {
        me.$loading({
          url: "/api/account/resource/getGroupsByModuleId",
          params: {
            moduleId: me.moduleId,
          },
        }).then(function (res) {
          if (res.success) {
            me.items = res.data;
          } else {
            me.$weui.topTips(res.message, 2000);
          }
        });
      }else{
        me.$weui.topTips('请先选择模块名称', 2000);
      }
    },
  },
};
</script>